/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest } from 'redux-saga/effects';

import * as commonSagas from '../_common/commonSagas';
import * as dynamicTablesSlice from './dynamicTablesSlice';

export default function* watchDynamicTablesSaga() {
	yield takeLatest(dynamicTablesSlice.getTableStart.type, commonSagas.getTable);
	yield takeLatest(dynamicTablesSlice.getItemStart.type, commonSagas.getItem);
	yield takeLatest(
		dynamicTablesSlice.createItemStart.type,
		commonSagas.createItem,
	);
	yield takeLatest(
		dynamicTablesSlice.updateItemStart.type,
		commonSagas.updateItem,
	);
	yield takeLatest(
		dynamicTablesSlice.deleteItemsStart.type,
		commonSagas.deleteItems,
	);
	yield takeLatest(
		dynamicTablesSlice.deleteItemStart.type,
		commonSagas.deleteItem,
	);
	yield takeLatest(
		dynamicTablesSlice.getTableStructureStart.type,
		commonSagas.getTableStructure,
	);
	yield takeLatest(
		dynamicTablesSlice.getItemDocumentsStart.type,
		commonSagas.getItemDocuments,
	);
	yield takeLatest(
		dynamicTablesSlice.uploadItemDocumentsStart.type,
		commonSagas.uploadItemDocuments,
	);
	yield takeLatest(
		dynamicTablesSlice.deleteItemDocumentStart.type,
		commonSagas.deleteItemDocument,
	);
	yield takeLatest(
		dynamicTablesSlice.getTableExcelStart.type,
		commonSagas.getTableExcel,
	);
}
